module.exports = __webpack_public_path__ + "media/images/flags/4x3/sco-4286a3d9f649ba35db3277311b1fc557.svg";